/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AccountRouteRouteImport } from './routes/account/route'
import { Route as DemoRouteImport } from './routes/demo'
import { Route as DevRouteImport } from './routes/dev'
import { Route as ForgotRouteImport } from './routes/forgot'
import { Route as InboxRouteRouteImport } from './routes/inbox/route'
import { Route as MaintenanceRouteImport } from './routes/maintenance'
import { Route as MeRouteRouteImport } from './routes/me/route'
import { Route as PlatformRouteRouteImport } from './routes/platform/route'
import { Route as ResetRouteImport } from './routes/reset'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as SignUpRouteImport } from './routes/sign-up'
import { Route as VerifyRouteImport } from './routes/verify'
import { Route as AccountIndexRouteImport } from './routes/account/index'
import { Route as AccountAboutRouteImport } from './routes/account/about'
import { Route as AccountDeleteRouteImport } from './routes/account/delete'
import { Route as AccountDevicesRouteImport } from './routes/account/devices'
import { Route as AccountEmailRouteImport } from './routes/account/email'
import { Route as AccountExportRouteImport } from './routes/account/export'
import { Route as AccountNotificationsRouteImport } from './routes/account/notifications'
import { Route as AccountPasswordRouteImport } from './routes/account/password'
import { Route as AccountPreferencesRouteImport } from './routes/account/preferences'
import { Route as AccountProfileRouteImport } from './routes/account/profile'
import { Route as AccountTokensRouteImport } from './routes/account/tokens'
import { Route as GalleryIndexRouteImport } from './routes/gallery/index'
import { Route as GalleryComponentIdRouteImport } from './routes/gallery/$componentId'
import { Route as InboxIndexRouteImport } from './routes/inbox/index'
import { Route as InviteCodeRouteImport } from './routes/invite/$code'
import { Route as MeIndexRouteImport } from './routes/me/index'
import { Route as OOrgSlugRouteRouteImport } from './routes/o/$orgSlug/route'
import { Route as PlatformIndexRouteImport } from './routes/platform/index'
import { Route as PlatformAuditRouteImport } from './routes/platform/audit'
import { Route as PlatformConfigRouteImport } from './routes/platform/config'
import { Route as PlatformDemoRouteImport } from './routes/platform/demo'
import { Route as PlatformFlagsRouteImport } from './routes/platform/flags'
import { Route as PlatformJobsRouteImport } from './routes/platform/jobs'
import { Route as PlatformPlansRouteImport } from './routes/platform/plans'
import { Route as PlatformStaffRouteImport } from './routes/platform/staff'
import { Route as PlatformSystemRouteImport } from './routes/platform/system'
import { Route as PlatformUsersRouteImport } from './routes/platform/users'
import { Route as WelcomeIndexRouteImport } from './routes/welcome/index'
import { Route as WelcomeProfileRouteImport } from './routes/welcome/profile'
import { Route as OOrgSlugIndexRouteImport } from './routes/o/$orgSlug/index'
import { Route as PlatformOrgsIndexRouteImport } from './routes/platform/orgs/index'
import { Route as PlatformOrgsOrgIdRouteImport } from './routes/platform/orgs/$orgId'
import { Route as WelcomeInviteSlugRouteImport } from './routes/welcome/invite/$slug'
import { Route as OOrgSlugOrganizationIndexRouteImport } from './routes/o/$orgSlug/organization/index'
import { Route as OOrgSlugOrganizationAuditRouteImport } from './routes/o/$orgSlug/organization/audit'
import { Route as OOrgSlugOrganizationDangerRouteImport } from './routes/o/$orgSlug/organization/danger'
import { Route as OOrgSlugOrganizationGeneralRouteImport } from './routes/o/$orgSlug/organization/general'
import { Route as OOrgSlugOrganizationPlanRouteImport } from './routes/o/$orgSlug/organization/plan'
import { Route as OOrgSlugOrganizationRolesRouteImport } from './routes/o/$orgSlug/organization/roles'
import { Route as OOrgSlugPeopleIndexRouteImport } from './routes/o/$orgSlug/people/index'
import { Route as OOrgSlugPeopleInvitationsRouteImport } from './routes/o/$orgSlug/people/invitations'
import { Route as OOrgSlugPeopleInviteRouteImport } from './routes/o/$orgSlug/people/invite'
import { Route as OOrgSlugTasksIndexRouteImport } from './routes/o/$orgSlug/tasks/index'
import { Route as OOrgSlugTasksInsightsRouteImport } from './routes/o/$orgSlug/tasks/insights'
import { Route as OOrgSlugTasksNewRouteImport } from './routes/o/$orgSlug/tasks/new'
import { Route as OOrgSlugPeopleMembershipIdIndexRouteImport } from './routes/o/$orgSlug/people/$membershipId/index'
import { Route as OOrgSlugPeopleMembershipIdAccessRouteImport } from './routes/o/$orgSlug/people/$membershipId/access'
import { Route as OOrgSlugPeopleTeamsIndexRouteImport } from './routes/o/$orgSlug/people/teams/index'
import { Route as OOrgSlugPeopleTeamsTeamIdRouteImport } from './routes/o/$orgSlug/people/teams/$teamId'
import { Route as OOrgSlugTasksTaskIdIndexRouteImport } from './routes/o/$orgSlug/tasks/$taskId/index'
import { Route as OOrgSlugTasksTaskIdEditRouteImport } from './routes/o/$orgSlug/tasks/$taskId/edit'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountRouteRoute = AccountRouteRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => rootRouteImport,
} as any)
const DemoRoute = DemoRouteImport.update({
  id: '/demo',
  path: '/demo',
  getParentRoute: () => rootRouteImport,
} as any)
const DevRoute = DevRouteImport.update({
  id: '/dev',
  path: '/dev',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotRoute = ForgotRouteImport.update({
  id: '/forgot',
  path: '/forgot',
  getParentRoute: () => rootRouteImport,
} as any)
const InboxRouteRoute = InboxRouteRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => rootRouteImport,
} as any)
const MaintenanceRoute = MaintenanceRouteImport.update({
  id: '/maintenance',
  path: '/maintenance',
  getParentRoute: () => rootRouteImport,
} as any)
const MeRouteRoute = MeRouteRouteImport.update({
  id: '/me',
  path: '/me',
  getParentRoute: () => rootRouteImport,
} as any)
const PlatformRouteRoute = PlatformRouteRouteImport.update({
  id: '/platform',
  path: '/platform',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetRoute = ResetRouteImport.update({
  id: '/reset',
  path: '/reset',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const SignUpRoute = SignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const VerifyRoute = VerifyRouteImport.update({
  id: '/verify',
  path: '/verify',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountIndexRoute = AccountIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AccountRouteRoute,
} as any)
const AccountAboutRoute = AccountAboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => AccountRouteRoute,
} as any)
const AccountDeleteRoute = AccountDeleteRouteImport.update({
  id: '/delete',
  path: '/delete',
  getParentRoute: () => AccountRouteRoute,
} as any)
const AccountDevicesRoute = AccountDevicesRouteImport.update({
  id: '/devices',
  path: '/devices',
  getParentRoute: () => AccountRouteRoute,
} as any)
const AccountEmailRoute = AccountEmailRouteImport.update({
  id: '/email',
  path: '/email',
  getParentRoute: () => AccountRouteRoute,
} as any)
const AccountExportRoute = AccountExportRouteImport.update({
  id: '/export',
  path: '/export',
  getParentRoute: () => AccountRouteRoute,
} as any)
const AccountNotificationsRoute = AccountNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => AccountRouteRoute,
} as any)
const AccountPasswordRoute = AccountPasswordRouteImport.update({
  id: '/password',
  path: '/password',
  getParentRoute: () => AccountRouteRoute,
} as any)
const AccountPreferencesRoute = AccountPreferencesRouteImport.update({
  id: '/preferences',
  path: '/preferences',
  getParentRoute: () => AccountRouteRoute,
} as any)
const AccountProfileRoute = AccountProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AccountRouteRoute,
} as any)
const AccountTokensRoute = AccountTokensRouteImport.update({
  id: '/tokens',
  path: '/tokens',
  getParentRoute: () => AccountRouteRoute,
} as any)
const GalleryIndexRoute = GalleryIndexRouteImport.update({
  id: '/gallery/',
  path: '/gallery/',
  getParentRoute: () => rootRouteImport,
} as any)
const GalleryComponentIdRoute = GalleryComponentIdRouteImport.update({
  id: '/gallery/$componentId',
  path: '/gallery/$componentId',
  getParentRoute: () => rootRouteImport,
} as any)
const InboxIndexRoute = InboxIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => InboxRouteRoute,
} as any)
const InviteCodeRoute = InviteCodeRouteImport.update({
  id: '/invite/$code',
  path: '/invite/$code',
  getParentRoute: () => rootRouteImport,
} as any)
const MeIndexRoute = MeIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MeRouteRoute,
} as any)
const OOrgSlugRouteRoute = OOrgSlugRouteRouteImport.update({
  id: '/o/$orgSlug',
  path: '/o/$orgSlug',
  getParentRoute: () => rootRouteImport,
} as any)
const PlatformIndexRoute = PlatformIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PlatformRouteRoute,
} as any)
const PlatformAuditRoute = PlatformAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => PlatformRouteRoute,
} as any)
const PlatformConfigRoute = PlatformConfigRouteImport.update({
  id: '/config',
  path: '/config',
  getParentRoute: () => PlatformRouteRoute,
} as any)
const PlatformDemoRoute = PlatformDemoRouteImport.update({
  id: '/demo',
  path: '/demo',
  getParentRoute: () => PlatformRouteRoute,
} as any)
const PlatformFlagsRoute = PlatformFlagsRouteImport.update({
  id: '/flags',
  path: '/flags',
  getParentRoute: () => PlatformRouteRoute,
} as any)
const PlatformJobsRoute = PlatformJobsRouteImport.update({
  id: '/jobs',
  path: '/jobs',
  getParentRoute: () => PlatformRouteRoute,
} as any)
const PlatformPlansRoute = PlatformPlansRouteImport.update({
  id: '/plans',
  path: '/plans',
  getParentRoute: () => PlatformRouteRoute,
} as any)
const PlatformStaffRoute = PlatformStaffRouteImport.update({
  id: '/staff',
  path: '/staff',
  getParentRoute: () => PlatformRouteRoute,
} as any)
const PlatformSystemRoute = PlatformSystemRouteImport.update({
  id: '/system',
  path: '/system',
  getParentRoute: () => PlatformRouteRoute,
} as any)
const PlatformUsersRoute = PlatformUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => PlatformRouteRoute,
} as any)
const WelcomeIndexRoute = WelcomeIndexRouteImport.update({
  id: '/welcome/',
  path: '/welcome/',
  getParentRoute: () => rootRouteImport,
} as any)
const WelcomeProfileRoute = WelcomeProfileRouteImport.update({
  id: '/welcome/profile',
  path: '/welcome/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const OOrgSlugIndexRoute = OOrgSlugIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OOrgSlugRouteRoute,
} as any)
const PlatformOrgsIndexRoute = PlatformOrgsIndexRouteImport.update({
  id: '/orgs/',
  path: '/orgs/',
  getParentRoute: () => PlatformRouteRoute,
} as any)
const PlatformOrgsOrgIdRoute = PlatformOrgsOrgIdRouteImport.update({
  id: '/orgs/$orgId',
  path: '/orgs/$orgId',
  getParentRoute: () => PlatformRouteRoute,
} as any)
const WelcomeInviteSlugRoute = WelcomeInviteSlugRouteImport.update({
  id: '/welcome/invite/$slug',
  path: '/welcome/invite/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const OOrgSlugOrganizationIndexRoute =
  OOrgSlugOrganizationIndexRouteImport.update({
    id: '/organization/',
    path: '/organization/',
    getParentRoute: () => OOrgSlugRouteRoute,
  } as any)
const OOrgSlugOrganizationAuditRoute =
  OOrgSlugOrganizationAuditRouteImport.update({
    id: '/organization/audit',
    path: '/organization/audit',
    getParentRoute: () => OOrgSlugRouteRoute,
  } as any)
const OOrgSlugOrganizationDangerRoute =
  OOrgSlugOrganizationDangerRouteImport.update({
    id: '/organization/danger',
    path: '/organization/danger',
    getParentRoute: () => OOrgSlugRouteRoute,
  } as any)
const OOrgSlugOrganizationGeneralRoute =
  OOrgSlugOrganizationGeneralRouteImport.update({
    id: '/organization/general',
    path: '/organization/general',
    getParentRoute: () => OOrgSlugRouteRoute,
  } as any)
const OOrgSlugOrganizationPlanRoute =
  OOrgSlugOrganizationPlanRouteImport.update({
    id: '/organization/plan',
    path: '/organization/plan',
    getParentRoute: () => OOrgSlugRouteRoute,
  } as any)
const OOrgSlugOrganizationRolesRoute =
  OOrgSlugOrganizationRolesRouteImport.update({
    id: '/organization/roles',
    path: '/organization/roles',
    getParentRoute: () => OOrgSlugRouteRoute,
  } as any)
const OOrgSlugPeopleIndexRoute = OOrgSlugPeopleIndexRouteImport.update({
  id: '/people/',
  path: '/people/',
  getParentRoute: () => OOrgSlugRouteRoute,
} as any)
const OOrgSlugPeopleInvitationsRoute =
  OOrgSlugPeopleInvitationsRouteImport.update({
    id: '/people/invitations',
    path: '/people/invitations',
    getParentRoute: () => OOrgSlugRouteRoute,
  } as any)
const OOrgSlugPeopleInviteRoute = OOrgSlugPeopleInviteRouteImport.update({
  id: '/people/invite',
  path: '/people/invite',
  getParentRoute: () => OOrgSlugRouteRoute,
} as any)
const OOrgSlugTasksIndexRoute = OOrgSlugTasksIndexRouteImport.update({
  id: '/tasks/',
  path: '/tasks/',
  getParentRoute: () => OOrgSlugRouteRoute,
} as any)
const OOrgSlugTasksInsightsRoute = OOrgSlugTasksInsightsRouteImport.update({
  id: '/tasks/insights',
  path: '/tasks/insights',
  getParentRoute: () => OOrgSlugRouteRoute,
} as any)
const OOrgSlugTasksNewRoute = OOrgSlugTasksNewRouteImport.update({
  id: '/tasks/new',
  path: '/tasks/new',
  getParentRoute: () => OOrgSlugRouteRoute,
} as any)
const OOrgSlugPeopleMembershipIdIndexRoute =
  OOrgSlugPeopleMembershipIdIndexRouteImport.update({
    id: '/people/$membershipId/',
    path: '/people/$membershipId/',
    getParentRoute: () => OOrgSlugRouteRoute,
  } as any)
const OOrgSlugPeopleMembershipIdAccessRoute =
  OOrgSlugPeopleMembershipIdAccessRouteImport.update({
    id: '/people/$membershipId/access',
    path: '/people/$membershipId/access',
    getParentRoute: () => OOrgSlugRouteRoute,
  } as any)
const OOrgSlugPeopleTeamsIndexRoute =
  OOrgSlugPeopleTeamsIndexRouteImport.update({
    id: '/people/teams/',
    path: '/people/teams/',
    getParentRoute: () => OOrgSlugRouteRoute,
  } as any)
const OOrgSlugPeopleTeamsTeamIdRoute =
  OOrgSlugPeopleTeamsTeamIdRouteImport.update({
    id: '/people/teams/$teamId',
    path: '/people/teams/$teamId',
    getParentRoute: () => OOrgSlugRouteRoute,
  } as any)
const OOrgSlugTasksTaskIdIndexRoute =
  OOrgSlugTasksTaskIdIndexRouteImport.update({
    id: '/tasks/$taskId/',
    path: '/tasks/$taskId/',
    getParentRoute: () => OOrgSlugRouteRoute,
  } as any)
const OOrgSlugTasksTaskIdEditRoute = OOrgSlugTasksTaskIdEditRouteImport.update({
  id: '/tasks/$taskId/edit',
  path: '/tasks/$taskId/edit',
  getParentRoute: () => OOrgSlugRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/account': typeof AccountRouteRouteWithChildren
  '/inbox': typeof InboxRouteRouteWithChildren
  '/me': typeof MeRouteRouteWithChildren
  '/platform': typeof PlatformRouteRouteWithChildren
  '/demo': typeof DemoRoute
  '/dev': typeof DevRoute
  '/forgot': typeof ForgotRoute
  '/maintenance': typeof MaintenanceRoute
  '/reset': typeof ResetRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/verify': typeof VerifyRoute
  '/o/$orgSlug': typeof OOrgSlugRouteRouteWithChildren
  '/account/about': typeof AccountAboutRoute
  '/account/delete': typeof AccountDeleteRoute
  '/account/devices': typeof AccountDevicesRoute
  '/account/email': typeof AccountEmailRoute
  '/account/export': typeof AccountExportRoute
  '/account/notifications': typeof AccountNotificationsRoute
  '/account/password': typeof AccountPasswordRoute
  '/account/preferences': typeof AccountPreferencesRoute
  '/account/profile': typeof AccountProfileRoute
  '/account/tokens': typeof AccountTokensRoute
  '/gallery/$componentId': typeof GalleryComponentIdRoute
  '/invite/$code': typeof InviteCodeRoute
  '/platform/audit': typeof PlatformAuditRoute
  '/platform/config': typeof PlatformConfigRoute
  '/platform/demo': typeof PlatformDemoRoute
  '/platform/flags': typeof PlatformFlagsRoute
  '/platform/jobs': typeof PlatformJobsRoute
  '/platform/plans': typeof PlatformPlansRoute
  '/platform/staff': typeof PlatformStaffRoute
  '/platform/system': typeof PlatformSystemRoute
  '/platform/users': typeof PlatformUsersRoute
  '/welcome/profile': typeof WelcomeProfileRoute
  '/account/': typeof AccountIndexRoute
  '/gallery/': typeof GalleryIndexRoute
  '/inbox/': typeof InboxIndexRoute
  '/me/': typeof MeIndexRoute
  '/platform/': typeof PlatformIndexRoute
  '/welcome/': typeof WelcomeIndexRoute
  '/platform/orgs/$orgId': typeof PlatformOrgsOrgIdRoute
  '/welcome/invite/$slug': typeof WelcomeInviteSlugRoute
  '/o/$orgSlug/': typeof OOrgSlugIndexRoute
  '/platform/orgs/': typeof PlatformOrgsIndexRoute
  '/o/$orgSlug/organization/audit': typeof OOrgSlugOrganizationAuditRoute
  '/o/$orgSlug/organization/danger': typeof OOrgSlugOrganizationDangerRoute
  '/o/$orgSlug/organization/general': typeof OOrgSlugOrganizationGeneralRoute
  '/o/$orgSlug/organization/plan': typeof OOrgSlugOrganizationPlanRoute
  '/o/$orgSlug/organization/roles': typeof OOrgSlugOrganizationRolesRoute
  '/o/$orgSlug/people/invitations': typeof OOrgSlugPeopleInvitationsRoute
  '/o/$orgSlug/people/invite': typeof OOrgSlugPeopleInviteRoute
  '/o/$orgSlug/tasks/insights': typeof OOrgSlugTasksInsightsRoute
  '/o/$orgSlug/tasks/new': typeof OOrgSlugTasksNewRoute
  '/o/$orgSlug/organization/': typeof OOrgSlugOrganizationIndexRoute
  '/o/$orgSlug/people/': typeof OOrgSlugPeopleIndexRoute
  '/o/$orgSlug/tasks/': typeof OOrgSlugTasksIndexRoute
  '/o/$orgSlug/people/$membershipId/access': typeof OOrgSlugPeopleMembershipIdAccessRoute
  '/o/$orgSlug/people/teams/$teamId': typeof OOrgSlugPeopleTeamsTeamIdRoute
  '/o/$orgSlug/tasks/$taskId/edit': typeof OOrgSlugTasksTaskIdEditRoute
  '/o/$orgSlug/people/$membershipId/': typeof OOrgSlugPeopleMembershipIdIndexRoute
  '/o/$orgSlug/people/teams/': typeof OOrgSlugPeopleTeamsIndexRoute
  '/o/$orgSlug/tasks/$taskId/': typeof OOrgSlugTasksTaskIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/demo': typeof DemoRoute
  '/dev': typeof DevRoute
  '/forgot': typeof ForgotRoute
  '/maintenance': typeof MaintenanceRoute
  '/reset': typeof ResetRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/verify': typeof VerifyRoute
  '/account/about': typeof AccountAboutRoute
  '/account/delete': typeof AccountDeleteRoute
  '/account/devices': typeof AccountDevicesRoute
  '/account/email': typeof AccountEmailRoute
  '/account/export': typeof AccountExportRoute
  '/account/notifications': typeof AccountNotificationsRoute
  '/account/password': typeof AccountPasswordRoute
  '/account/preferences': typeof AccountPreferencesRoute
  '/account/profile': typeof AccountProfileRoute
  '/account/tokens': typeof AccountTokensRoute
  '/gallery/$componentId': typeof GalleryComponentIdRoute
  '/invite/$code': typeof InviteCodeRoute
  '/platform/audit': typeof PlatformAuditRoute
  '/platform/config': typeof PlatformConfigRoute
  '/platform/demo': typeof PlatformDemoRoute
  '/platform/flags': typeof PlatformFlagsRoute
  '/platform/jobs': typeof PlatformJobsRoute
  '/platform/plans': typeof PlatformPlansRoute
  '/platform/staff': typeof PlatformStaffRoute
  '/platform/system': typeof PlatformSystemRoute
  '/platform/users': typeof PlatformUsersRoute
  '/welcome/profile': typeof WelcomeProfileRoute
  '/account': typeof AccountIndexRoute
  '/gallery': typeof GalleryIndexRoute
  '/inbox': typeof InboxIndexRoute
  '/me': typeof MeIndexRoute
  '/platform': typeof PlatformIndexRoute
  '/welcome': typeof WelcomeIndexRoute
  '/platform/orgs/$orgId': typeof PlatformOrgsOrgIdRoute
  '/welcome/invite/$slug': typeof WelcomeInviteSlugRoute
  '/o/$orgSlug': typeof OOrgSlugIndexRoute
  '/platform/orgs': typeof PlatformOrgsIndexRoute
  '/o/$orgSlug/organization/audit': typeof OOrgSlugOrganizationAuditRoute
  '/o/$orgSlug/organization/danger': typeof OOrgSlugOrganizationDangerRoute
  '/o/$orgSlug/organization/general': typeof OOrgSlugOrganizationGeneralRoute
  '/o/$orgSlug/organization/plan': typeof OOrgSlugOrganizationPlanRoute
  '/o/$orgSlug/organization/roles': typeof OOrgSlugOrganizationRolesRoute
  '/o/$orgSlug/people/invitations': typeof OOrgSlugPeopleInvitationsRoute
  '/o/$orgSlug/people/invite': typeof OOrgSlugPeopleInviteRoute
  '/o/$orgSlug/tasks/insights': typeof OOrgSlugTasksInsightsRoute
  '/o/$orgSlug/tasks/new': typeof OOrgSlugTasksNewRoute
  '/o/$orgSlug/organization': typeof OOrgSlugOrganizationIndexRoute
  '/o/$orgSlug/people': typeof OOrgSlugPeopleIndexRoute
  '/o/$orgSlug/tasks': typeof OOrgSlugTasksIndexRoute
  '/o/$orgSlug/people/$membershipId/access': typeof OOrgSlugPeopleMembershipIdAccessRoute
  '/o/$orgSlug/people/teams/$teamId': typeof OOrgSlugPeopleTeamsTeamIdRoute
  '/o/$orgSlug/tasks/$taskId/edit': typeof OOrgSlugTasksTaskIdEditRoute
  '/o/$orgSlug/people/$membershipId': typeof OOrgSlugPeopleMembershipIdIndexRoute
  '/o/$orgSlug/people/teams': typeof OOrgSlugPeopleTeamsIndexRoute
  '/o/$orgSlug/tasks/$taskId': typeof OOrgSlugTasksTaskIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/account': typeof AccountRouteRouteWithChildren
  '/inbox': typeof InboxRouteRouteWithChildren
  '/me': typeof MeRouteRouteWithChildren
  '/platform': typeof PlatformRouteRouteWithChildren
  '/demo': typeof DemoRoute
  '/dev': typeof DevRoute
  '/forgot': typeof ForgotRoute
  '/maintenance': typeof MaintenanceRoute
  '/reset': typeof ResetRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/verify': typeof VerifyRoute
  '/o/$orgSlug': typeof OOrgSlugRouteRouteWithChildren
  '/account/about': typeof AccountAboutRoute
  '/account/delete': typeof AccountDeleteRoute
  '/account/devices': typeof AccountDevicesRoute
  '/account/email': typeof AccountEmailRoute
  '/account/export': typeof AccountExportRoute
  '/account/notifications': typeof AccountNotificationsRoute
  '/account/password': typeof AccountPasswordRoute
  '/account/preferences': typeof AccountPreferencesRoute
  '/account/profile': typeof AccountProfileRoute
  '/account/tokens': typeof AccountTokensRoute
  '/gallery/$componentId': typeof GalleryComponentIdRoute
  '/invite/$code': typeof InviteCodeRoute
  '/platform/audit': typeof PlatformAuditRoute
  '/platform/config': typeof PlatformConfigRoute
  '/platform/demo': typeof PlatformDemoRoute
  '/platform/flags': typeof PlatformFlagsRoute
  '/platform/jobs': typeof PlatformJobsRoute
  '/platform/plans': typeof PlatformPlansRoute
  '/platform/staff': typeof PlatformStaffRoute
  '/platform/system': typeof PlatformSystemRoute
  '/platform/users': typeof PlatformUsersRoute
  '/welcome/profile': typeof WelcomeProfileRoute
  '/account/': typeof AccountIndexRoute
  '/gallery/': typeof GalleryIndexRoute
  '/inbox/': typeof InboxIndexRoute
  '/me/': typeof MeIndexRoute
  '/platform/': typeof PlatformIndexRoute
  '/welcome/': typeof WelcomeIndexRoute
  '/platform/orgs/$orgId': typeof PlatformOrgsOrgIdRoute
  '/welcome/invite/$slug': typeof WelcomeInviteSlugRoute
  '/o/$orgSlug/': typeof OOrgSlugIndexRoute
  '/platform/orgs/': typeof PlatformOrgsIndexRoute
  '/o/$orgSlug/organization/audit': typeof OOrgSlugOrganizationAuditRoute
  '/o/$orgSlug/organization/danger': typeof OOrgSlugOrganizationDangerRoute
  '/o/$orgSlug/organization/general': typeof OOrgSlugOrganizationGeneralRoute
  '/o/$orgSlug/organization/plan': typeof OOrgSlugOrganizationPlanRoute
  '/o/$orgSlug/organization/roles': typeof OOrgSlugOrganizationRolesRoute
  '/o/$orgSlug/people/invitations': typeof OOrgSlugPeopleInvitationsRoute
  '/o/$orgSlug/people/invite': typeof OOrgSlugPeopleInviteRoute
  '/o/$orgSlug/tasks/insights': typeof OOrgSlugTasksInsightsRoute
  '/o/$orgSlug/tasks/new': typeof OOrgSlugTasksNewRoute
  '/o/$orgSlug/organization/': typeof OOrgSlugOrganizationIndexRoute
  '/o/$orgSlug/people/': typeof OOrgSlugPeopleIndexRoute
  '/o/$orgSlug/tasks/': typeof OOrgSlugTasksIndexRoute
  '/o/$orgSlug/people/$membershipId/access': typeof OOrgSlugPeopleMembershipIdAccessRoute
  '/o/$orgSlug/people/teams/$teamId': typeof OOrgSlugPeopleTeamsTeamIdRoute
  '/o/$orgSlug/tasks/$taskId/edit': typeof OOrgSlugTasksTaskIdEditRoute
  '/o/$orgSlug/people/$membershipId/': typeof OOrgSlugPeopleMembershipIdIndexRoute
  '/o/$orgSlug/people/teams/': typeof OOrgSlugPeopleTeamsIndexRoute
  '/o/$orgSlug/tasks/$taskId/': typeof OOrgSlugTasksTaskIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/account'
    | '/inbox'
    | '/me'
    | '/platform'
    | '/demo'
    | '/dev'
    | '/forgot'
    | '/maintenance'
    | '/reset'
    | '/sign-in'
    | '/sign-up'
    | '/verify'
    | '/o/$orgSlug'
    | '/account/about'
    | '/account/delete'
    | '/account/devices'
    | '/account/email'
    | '/account/export'
    | '/account/notifications'
    | '/account/password'
    | '/account/preferences'
    | '/account/profile'
    | '/account/tokens'
    | '/gallery/$componentId'
    | '/invite/$code'
    | '/platform/audit'
    | '/platform/config'
    | '/platform/demo'
    | '/platform/flags'
    | '/platform/jobs'
    | '/platform/plans'
    | '/platform/staff'
    | '/platform/system'
    | '/platform/users'
    | '/welcome/profile'
    | '/account/'
    | '/gallery/'
    | '/inbox/'
    | '/me/'
    | '/platform/'
    | '/welcome/'
    | '/platform/orgs/$orgId'
    | '/welcome/invite/$slug'
    | '/o/$orgSlug/'
    | '/platform/orgs/'
    | '/o/$orgSlug/organization/audit'
    | '/o/$orgSlug/organization/danger'
    | '/o/$orgSlug/organization/general'
    | '/o/$orgSlug/organization/plan'
    | '/o/$orgSlug/organization/roles'
    | '/o/$orgSlug/people/invitations'
    | '/o/$orgSlug/people/invite'
    | '/o/$orgSlug/tasks/insights'
    | '/o/$orgSlug/tasks/new'
    | '/o/$orgSlug/organization/'
    | '/o/$orgSlug/people/'
    | '/o/$orgSlug/tasks/'
    | '/o/$orgSlug/people/$membershipId/access'
    | '/o/$orgSlug/people/teams/$teamId'
    | '/o/$orgSlug/tasks/$taskId/edit'
    | '/o/$orgSlug/people/$membershipId/'
    | '/o/$orgSlug/people/teams/'
    | '/o/$orgSlug/tasks/$taskId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/demo'
    | '/dev'
    | '/forgot'
    | '/maintenance'
    | '/reset'
    | '/sign-in'
    | '/sign-up'
    | '/verify'
    | '/account/about'
    | '/account/delete'
    | '/account/devices'
    | '/account/email'
    | '/account/export'
    | '/account/notifications'
    | '/account/password'
    | '/account/preferences'
    | '/account/profile'
    | '/account/tokens'
    | '/gallery/$componentId'
    | '/invite/$code'
    | '/platform/audit'
    | '/platform/config'
    | '/platform/demo'
    | '/platform/flags'
    | '/platform/jobs'
    | '/platform/plans'
    | '/platform/staff'
    | '/platform/system'
    | '/platform/users'
    | '/welcome/profile'
    | '/account'
    | '/gallery'
    | '/inbox'
    | '/me'
    | '/platform'
    | '/welcome'
    | '/platform/orgs/$orgId'
    | '/welcome/invite/$slug'
    | '/o/$orgSlug'
    | '/platform/orgs'
    | '/o/$orgSlug/organization/audit'
    | '/o/$orgSlug/organization/danger'
    | '/o/$orgSlug/organization/general'
    | '/o/$orgSlug/organization/plan'
    | '/o/$orgSlug/organization/roles'
    | '/o/$orgSlug/people/invitations'
    | '/o/$orgSlug/people/invite'
    | '/o/$orgSlug/tasks/insights'
    | '/o/$orgSlug/tasks/new'
    | '/o/$orgSlug/organization'
    | '/o/$orgSlug/people'
    | '/o/$orgSlug/tasks'
    | '/o/$orgSlug/people/$membershipId/access'
    | '/o/$orgSlug/people/teams/$teamId'
    | '/o/$orgSlug/tasks/$taskId/edit'
    | '/o/$orgSlug/people/$membershipId'
    | '/o/$orgSlug/people/teams'
    | '/o/$orgSlug/tasks/$taskId'
  id:
    | '__root__'
    | '/'
    | '/account'
    | '/inbox'
    | '/me'
    | '/platform'
    | '/demo'
    | '/dev'
    | '/forgot'
    | '/maintenance'
    | '/reset'
    | '/sign-in'
    | '/sign-up'
    | '/verify'
    | '/o/$orgSlug'
    | '/account/about'
    | '/account/delete'
    | '/account/devices'
    | '/account/email'
    | '/account/export'
    | '/account/notifications'
    | '/account/password'
    | '/account/preferences'
    | '/account/profile'
    | '/account/tokens'
    | '/gallery/$componentId'
    | '/invite/$code'
    | '/platform/audit'
    | '/platform/config'
    | '/platform/demo'
    | '/platform/flags'
    | '/platform/jobs'
    | '/platform/plans'
    | '/platform/staff'
    | '/platform/system'
    | '/platform/users'
    | '/welcome/profile'
    | '/account/'
    | '/gallery/'
    | '/inbox/'
    | '/me/'
    | '/platform/'
    | '/welcome/'
    | '/platform/orgs/$orgId'
    | '/welcome/invite/$slug'
    | '/o/$orgSlug/'
    | '/platform/orgs/'
    | '/o/$orgSlug/organization/audit'
    | '/o/$orgSlug/organization/danger'
    | '/o/$orgSlug/organization/general'
    | '/o/$orgSlug/organization/plan'
    | '/o/$orgSlug/organization/roles'
    | '/o/$orgSlug/people/invitations'
    | '/o/$orgSlug/people/invite'
    | '/o/$orgSlug/tasks/insights'
    | '/o/$orgSlug/tasks/new'
    | '/o/$orgSlug/organization/'
    | '/o/$orgSlug/people/'
    | '/o/$orgSlug/tasks/'
    | '/o/$orgSlug/people/$membershipId/access'
    | '/o/$orgSlug/people/teams/$teamId'
    | '/o/$orgSlug/tasks/$taskId/edit'
    | '/o/$orgSlug/people/$membershipId/'
    | '/o/$orgSlug/people/teams/'
    | '/o/$orgSlug/tasks/$taskId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AccountRouteRoute: typeof AccountRouteRouteWithChildren
  InboxRouteRoute: typeof InboxRouteRouteWithChildren
  MeRouteRoute: typeof MeRouteRouteWithChildren
  PlatformRouteRoute: typeof PlatformRouteRouteWithChildren
  DemoRoute: typeof DemoRoute
  DevRoute: typeof DevRoute
  ForgotRoute: typeof ForgotRoute
  MaintenanceRoute: typeof MaintenanceRoute
  ResetRoute: typeof ResetRoute
  SignInRoute: typeof SignInRoute
  SignUpRoute: typeof SignUpRoute
  VerifyRoute: typeof VerifyRoute
  OOrgSlugRouteRoute: typeof OOrgSlugRouteRouteWithChildren
  GalleryComponentIdRoute: typeof GalleryComponentIdRoute
  InviteCodeRoute: typeof InviteCodeRoute
  WelcomeProfileRoute: typeof WelcomeProfileRoute
  GalleryIndexRoute: typeof GalleryIndexRoute
  WelcomeIndexRoute: typeof WelcomeIndexRoute
  WelcomeInviteSlugRoute: typeof WelcomeInviteSlugRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account': {
      id: '/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AccountRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/demo': {
      id: '/demo'
      path: '/demo'
      fullPath: '/demo'
      preLoaderRoute: typeof DemoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev': {
      id: '/dev'
      path: '/dev'
      fullPath: '/dev'
      preLoaderRoute: typeof DevRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot': {
      id: '/forgot'
      path: '/forgot'
      fullPath: '/forgot'
      preLoaderRoute: typeof ForgotRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inbox': {
      id: '/inbox'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof InboxRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/maintenance': {
      id: '/maintenance'
      path: '/maintenance'
      fullPath: '/maintenance'
      preLoaderRoute: typeof MaintenanceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/me': {
      id: '/me'
      path: '/me'
      fullPath: '/me'
      preLoaderRoute: typeof MeRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/platform': {
      id: '/platform'
      path: '/platform'
      fullPath: '/platform'
      preLoaderRoute: typeof PlatformRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset': {
      id: '/reset'
      path: '/reset'
      fullPath: '/reset'
      preLoaderRoute: typeof ResetRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-up': {
      id: '/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof SignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verify': {
      id: '/verify'
      path: '/verify'
      fullPath: '/verify'
      preLoaderRoute: typeof VerifyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account/': {
      id: '/account/'
      path: '/'
      fullPath: '/account/'
      preLoaderRoute: typeof AccountIndexRouteImport
      parentRoute: typeof AccountRouteRoute
    }
    '/account/about': {
      id: '/account/about'
      path: '/about'
      fullPath: '/account/about'
      preLoaderRoute: typeof AccountAboutRouteImport
      parentRoute: typeof AccountRouteRoute
    }
    '/account/delete': {
      id: '/account/delete'
      path: '/delete'
      fullPath: '/account/delete'
      preLoaderRoute: typeof AccountDeleteRouteImport
      parentRoute: typeof AccountRouteRoute
    }
    '/account/devices': {
      id: '/account/devices'
      path: '/devices'
      fullPath: '/account/devices'
      preLoaderRoute: typeof AccountDevicesRouteImport
      parentRoute: typeof AccountRouteRoute
    }
    '/account/email': {
      id: '/account/email'
      path: '/email'
      fullPath: '/account/email'
      preLoaderRoute: typeof AccountEmailRouteImport
      parentRoute: typeof AccountRouteRoute
    }
    '/account/export': {
      id: '/account/export'
      path: '/export'
      fullPath: '/account/export'
      preLoaderRoute: typeof AccountExportRouteImport
      parentRoute: typeof AccountRouteRoute
    }
    '/account/notifications': {
      id: '/account/notifications'
      path: '/notifications'
      fullPath: '/account/notifications'
      preLoaderRoute: typeof AccountNotificationsRouteImport
      parentRoute: typeof AccountRouteRoute
    }
    '/account/password': {
      id: '/account/password'
      path: '/password'
      fullPath: '/account/password'
      preLoaderRoute: typeof AccountPasswordRouteImport
      parentRoute: typeof AccountRouteRoute
    }
    '/account/preferences': {
      id: '/account/preferences'
      path: '/preferences'
      fullPath: '/account/preferences'
      preLoaderRoute: typeof AccountPreferencesRouteImport
      parentRoute: typeof AccountRouteRoute
    }
    '/account/profile': {
      id: '/account/profile'
      path: '/profile'
      fullPath: '/account/profile'
      preLoaderRoute: typeof AccountProfileRouteImport
      parentRoute: typeof AccountRouteRoute
    }
    '/account/tokens': {
      id: '/account/tokens'
      path: '/tokens'
      fullPath: '/account/tokens'
      preLoaderRoute: typeof AccountTokensRouteImport
      parentRoute: typeof AccountRouteRoute
    }
    '/gallery/': {
      id: '/gallery/'
      path: '/gallery'
      fullPath: '/gallery/'
      preLoaderRoute: typeof GalleryIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/gallery/$componentId': {
      id: '/gallery/$componentId'
      path: '/gallery/$componentId'
      fullPath: '/gallery/$componentId'
      preLoaderRoute: typeof GalleryComponentIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inbox/': {
      id: '/inbox/'
      path: '/'
      fullPath: '/inbox/'
      preLoaderRoute: typeof InboxIndexRouteImport
      parentRoute: typeof InboxRouteRoute
    }
    '/invite/$code': {
      id: '/invite/$code'
      path: '/invite/$code'
      fullPath: '/invite/$code'
      preLoaderRoute: typeof InviteCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/me/': {
      id: '/me/'
      path: '/'
      fullPath: '/me/'
      preLoaderRoute: typeof MeIndexRouteImport
      parentRoute: typeof MeRouteRoute
    }
    '/o/$orgSlug': {
      id: '/o/$orgSlug'
      path: '/o/$orgSlug'
      fullPath: '/o/$orgSlug'
      preLoaderRoute: typeof OOrgSlugRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/platform/': {
      id: '/platform/'
      path: '/'
      fullPath: '/platform/'
      preLoaderRoute: typeof PlatformIndexRouteImport
      parentRoute: typeof PlatformRouteRoute
    }
    '/platform/audit': {
      id: '/platform/audit'
      path: '/audit'
      fullPath: '/platform/audit'
      preLoaderRoute: typeof PlatformAuditRouteImport
      parentRoute: typeof PlatformRouteRoute
    }
    '/platform/config': {
      id: '/platform/config'
      path: '/config'
      fullPath: '/platform/config'
      preLoaderRoute: typeof PlatformConfigRouteImport
      parentRoute: typeof PlatformRouteRoute
    }
    '/platform/demo': {
      id: '/platform/demo'
      path: '/demo'
      fullPath: '/platform/demo'
      preLoaderRoute: typeof PlatformDemoRouteImport
      parentRoute: typeof PlatformRouteRoute
    }
    '/platform/flags': {
      id: '/platform/flags'
      path: '/flags'
      fullPath: '/platform/flags'
      preLoaderRoute: typeof PlatformFlagsRouteImport
      parentRoute: typeof PlatformRouteRoute
    }
    '/platform/jobs': {
      id: '/platform/jobs'
      path: '/jobs'
      fullPath: '/platform/jobs'
      preLoaderRoute: typeof PlatformJobsRouteImport
      parentRoute: typeof PlatformRouteRoute
    }
    '/platform/plans': {
      id: '/platform/plans'
      path: '/plans'
      fullPath: '/platform/plans'
      preLoaderRoute: typeof PlatformPlansRouteImport
      parentRoute: typeof PlatformRouteRoute
    }
    '/platform/staff': {
      id: '/platform/staff'
      path: '/staff'
      fullPath: '/platform/staff'
      preLoaderRoute: typeof PlatformStaffRouteImport
      parentRoute: typeof PlatformRouteRoute
    }
    '/platform/system': {
      id: '/platform/system'
      path: '/system'
      fullPath: '/platform/system'
      preLoaderRoute: typeof PlatformSystemRouteImport
      parentRoute: typeof PlatformRouteRoute
    }
    '/platform/users': {
      id: '/platform/users'
      path: '/users'
      fullPath: '/platform/users'
      preLoaderRoute: typeof PlatformUsersRouteImport
      parentRoute: typeof PlatformRouteRoute
    }
    '/welcome/': {
      id: '/welcome/'
      path: '/welcome'
      fullPath: '/welcome/'
      preLoaderRoute: typeof WelcomeIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/welcome/profile': {
      id: '/welcome/profile'
      path: '/welcome/profile'
      fullPath: '/welcome/profile'
      preLoaderRoute: typeof WelcomeProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/o/$orgSlug/': {
      id: '/o/$orgSlug/'
      path: '/'
      fullPath: '/o/$orgSlug/'
      preLoaderRoute: typeof OOrgSlugIndexRouteImport
      parentRoute: typeof OOrgSlugRouteRoute
    }
    '/platform/orgs/': {
      id: '/platform/orgs/'
      path: '/orgs'
      fullPath: '/platform/orgs/'
      preLoaderRoute: typeof PlatformOrgsIndexRouteImport
      parentRoute: typeof PlatformRouteRoute
    }
    '/platform/orgs/$orgId': {
      id: '/platform/orgs/$orgId'
      path: '/orgs/$orgId'
      fullPath: '/platform/orgs/$orgId'
      preLoaderRoute: typeof PlatformOrgsOrgIdRouteImport
      parentRoute: typeof PlatformRouteRoute
    }
    '/welcome/invite/$slug': {
      id: '/welcome/invite/$slug'
      path: '/welcome/invite/$slug'
      fullPath: '/welcome/invite/$slug'
      preLoaderRoute: typeof WelcomeInviteSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/o/$orgSlug/organization/': {
      id: '/o/$orgSlug/organization/'
      path: '/organization'
      fullPath: '/o/$orgSlug/organization/'
      preLoaderRoute: typeof OOrgSlugOrganizationIndexRouteImport
      parentRoute: typeof OOrgSlugRouteRoute
    }
    '/o/$orgSlug/organization/audit': {
      id: '/o/$orgSlug/organization/audit'
      path: '/organization/audit'
      fullPath: '/o/$orgSlug/organization/audit'
      preLoaderRoute: typeof OOrgSlugOrganizationAuditRouteImport
      parentRoute: typeof OOrgSlugRouteRoute
    }
    '/o/$orgSlug/organization/danger': {
      id: '/o/$orgSlug/organization/danger'
      path: '/organization/danger'
      fullPath: '/o/$orgSlug/organization/danger'
      preLoaderRoute: typeof OOrgSlugOrganizationDangerRouteImport
      parentRoute: typeof OOrgSlugRouteRoute
    }
    '/o/$orgSlug/organization/general': {
      id: '/o/$orgSlug/organization/general'
      path: '/organization/general'
      fullPath: '/o/$orgSlug/organization/general'
      preLoaderRoute: typeof OOrgSlugOrganizationGeneralRouteImport
      parentRoute: typeof OOrgSlugRouteRoute
    }
    '/o/$orgSlug/organization/plan': {
      id: '/o/$orgSlug/organization/plan'
      path: '/organization/plan'
      fullPath: '/o/$orgSlug/organization/plan'
      preLoaderRoute: typeof OOrgSlugOrganizationPlanRouteImport
      parentRoute: typeof OOrgSlugRouteRoute
    }
    '/o/$orgSlug/organization/roles': {
      id: '/o/$orgSlug/organization/roles'
      path: '/organization/roles'
      fullPath: '/o/$orgSlug/organization/roles'
      preLoaderRoute: typeof OOrgSlugOrganizationRolesRouteImport
      parentRoute: typeof OOrgSlugRouteRoute
    }
    '/o/$orgSlug/people/': {
      id: '/o/$orgSlug/people/'
      path: '/people'
      fullPath: '/o/$orgSlug/people/'
      preLoaderRoute: typeof OOrgSlugPeopleIndexRouteImport
      parentRoute: typeof OOrgSlugRouteRoute
    }
    '/o/$orgSlug/people/invitations': {
      id: '/o/$orgSlug/people/invitations'
      path: '/people/invitations'
      fullPath: '/o/$orgSlug/people/invitations'
      preLoaderRoute: typeof OOrgSlugPeopleInvitationsRouteImport
      parentRoute: typeof OOrgSlugRouteRoute
    }
    '/o/$orgSlug/people/invite': {
      id: '/o/$orgSlug/people/invite'
      path: '/people/invite'
      fullPath: '/o/$orgSlug/people/invite'
      preLoaderRoute: typeof OOrgSlugPeopleInviteRouteImport
      parentRoute: typeof OOrgSlugRouteRoute
    }
    '/o/$orgSlug/tasks/': {
      id: '/o/$orgSlug/tasks/'
      path: '/tasks'
      fullPath: '/o/$orgSlug/tasks/'
      preLoaderRoute: typeof OOrgSlugTasksIndexRouteImport
      parentRoute: typeof OOrgSlugRouteRoute
    }
    '/o/$orgSlug/tasks/insights': {
      id: '/o/$orgSlug/tasks/insights'
      path: '/tasks/insights'
      fullPath: '/o/$orgSlug/tasks/insights'
      preLoaderRoute: typeof OOrgSlugTasksInsightsRouteImport
      parentRoute: typeof OOrgSlugRouteRoute
    }
    '/o/$orgSlug/tasks/new': {
      id: '/o/$orgSlug/tasks/new'
      path: '/tasks/new'
      fullPath: '/o/$orgSlug/tasks/new'
      preLoaderRoute: typeof OOrgSlugTasksNewRouteImport
      parentRoute: typeof OOrgSlugRouteRoute
    }
    '/o/$orgSlug/people/$membershipId/': {
      id: '/o/$orgSlug/people/$membershipId/'
      path: '/people/$membershipId'
      fullPath: '/o/$orgSlug/people/$membershipId/'
      preLoaderRoute: typeof OOrgSlugPeopleMembershipIdIndexRouteImport
      parentRoute: typeof OOrgSlugRouteRoute
    }
    '/o/$orgSlug/people/$membershipId/access': {
      id: '/o/$orgSlug/people/$membershipId/access'
      path: '/people/$membershipId/access'
      fullPath: '/o/$orgSlug/people/$membershipId/access'
      preLoaderRoute: typeof OOrgSlugPeopleMembershipIdAccessRouteImport
      parentRoute: typeof OOrgSlugRouteRoute
    }
    '/o/$orgSlug/people/teams/': {
      id: '/o/$orgSlug/people/teams/'
      path: '/people/teams'
      fullPath: '/o/$orgSlug/people/teams/'
      preLoaderRoute: typeof OOrgSlugPeopleTeamsIndexRouteImport
      parentRoute: typeof OOrgSlugRouteRoute
    }
    '/o/$orgSlug/people/teams/$teamId': {
      id: '/o/$orgSlug/people/teams/$teamId'
      path: '/people/teams/$teamId'
      fullPath: '/o/$orgSlug/people/teams/$teamId'
      preLoaderRoute: typeof OOrgSlugPeopleTeamsTeamIdRouteImport
      parentRoute: typeof OOrgSlugRouteRoute
    }
    '/o/$orgSlug/tasks/$taskId/': {
      id: '/o/$orgSlug/tasks/$taskId/'
      path: '/tasks/$taskId'
      fullPath: '/o/$orgSlug/tasks/$taskId/'
      preLoaderRoute: typeof OOrgSlugTasksTaskIdIndexRouteImport
      parentRoute: typeof OOrgSlugRouteRoute
    }
    '/o/$orgSlug/tasks/$taskId/edit': {
      id: '/o/$orgSlug/tasks/$taskId/edit'
      path: '/tasks/$taskId/edit'
      fullPath: '/o/$orgSlug/tasks/$taskId/edit'
      preLoaderRoute: typeof OOrgSlugTasksTaskIdEditRouteImport
      parentRoute: typeof OOrgSlugRouteRoute
    }
  }
}

interface AccountRouteRouteChildren {
  AccountAboutRoute: typeof AccountAboutRoute
  AccountDeleteRoute: typeof AccountDeleteRoute
  AccountDevicesRoute: typeof AccountDevicesRoute
  AccountEmailRoute: typeof AccountEmailRoute
  AccountExportRoute: typeof AccountExportRoute
  AccountNotificationsRoute: typeof AccountNotificationsRoute
  AccountPasswordRoute: typeof AccountPasswordRoute
  AccountPreferencesRoute: typeof AccountPreferencesRoute
  AccountProfileRoute: typeof AccountProfileRoute
  AccountTokensRoute: typeof AccountTokensRoute
  AccountIndexRoute: typeof AccountIndexRoute
}

const AccountRouteRouteChildren: AccountRouteRouteChildren = {
  AccountAboutRoute: AccountAboutRoute,
  AccountDeleteRoute: AccountDeleteRoute,
  AccountDevicesRoute: AccountDevicesRoute,
  AccountEmailRoute: AccountEmailRoute,
  AccountExportRoute: AccountExportRoute,
  AccountNotificationsRoute: AccountNotificationsRoute,
  AccountPasswordRoute: AccountPasswordRoute,
  AccountPreferencesRoute: AccountPreferencesRoute,
  AccountProfileRoute: AccountProfileRoute,
  AccountTokensRoute: AccountTokensRoute,
  AccountIndexRoute: AccountIndexRoute,
}

const AccountRouteRouteWithChildren = AccountRouteRoute._addFileChildren(
  AccountRouteRouteChildren,
)

interface InboxRouteRouteChildren {
  InboxIndexRoute: typeof InboxIndexRoute
}

const InboxRouteRouteChildren: InboxRouteRouteChildren = {
  InboxIndexRoute: InboxIndexRoute,
}

const InboxRouteRouteWithChildren = InboxRouteRoute._addFileChildren(
  InboxRouteRouteChildren,
)

interface MeRouteRouteChildren {
  MeIndexRoute: typeof MeIndexRoute
}

const MeRouteRouteChildren: MeRouteRouteChildren = {
  MeIndexRoute: MeIndexRoute,
}

const MeRouteRouteWithChildren =
  MeRouteRoute._addFileChildren(MeRouteRouteChildren)

interface PlatformRouteRouteChildren {
  PlatformAuditRoute: typeof PlatformAuditRoute
  PlatformConfigRoute: typeof PlatformConfigRoute
  PlatformDemoRoute: typeof PlatformDemoRoute
  PlatformFlagsRoute: typeof PlatformFlagsRoute
  PlatformJobsRoute: typeof PlatformJobsRoute
  PlatformPlansRoute: typeof PlatformPlansRoute
  PlatformStaffRoute: typeof PlatformStaffRoute
  PlatformSystemRoute: typeof PlatformSystemRoute
  PlatformUsersRoute: typeof PlatformUsersRoute
  PlatformIndexRoute: typeof PlatformIndexRoute
  PlatformOrgsOrgIdRoute: typeof PlatformOrgsOrgIdRoute
  PlatformOrgsIndexRoute: typeof PlatformOrgsIndexRoute
}

const PlatformRouteRouteChildren: PlatformRouteRouteChildren = {
  PlatformAuditRoute: PlatformAuditRoute,
  PlatformConfigRoute: PlatformConfigRoute,
  PlatformDemoRoute: PlatformDemoRoute,
  PlatformFlagsRoute: PlatformFlagsRoute,
  PlatformJobsRoute: PlatformJobsRoute,
  PlatformPlansRoute: PlatformPlansRoute,
  PlatformStaffRoute: PlatformStaffRoute,
  PlatformSystemRoute: PlatformSystemRoute,
  PlatformUsersRoute: PlatformUsersRoute,
  PlatformIndexRoute: PlatformIndexRoute,
  PlatformOrgsOrgIdRoute: PlatformOrgsOrgIdRoute,
  PlatformOrgsIndexRoute: PlatformOrgsIndexRoute,
}

const PlatformRouteRouteWithChildren = PlatformRouteRoute._addFileChildren(
  PlatformRouteRouteChildren,
)

interface OOrgSlugRouteRouteChildren {
  OOrgSlugIndexRoute: typeof OOrgSlugIndexRoute
  OOrgSlugOrganizationAuditRoute: typeof OOrgSlugOrganizationAuditRoute
  OOrgSlugOrganizationDangerRoute: typeof OOrgSlugOrganizationDangerRoute
  OOrgSlugOrganizationGeneralRoute: typeof OOrgSlugOrganizationGeneralRoute
  OOrgSlugOrganizationPlanRoute: typeof OOrgSlugOrganizationPlanRoute
  OOrgSlugOrganizationRolesRoute: typeof OOrgSlugOrganizationRolesRoute
  OOrgSlugPeopleInvitationsRoute: typeof OOrgSlugPeopleInvitationsRoute
  OOrgSlugPeopleInviteRoute: typeof OOrgSlugPeopleInviteRoute
  OOrgSlugTasksInsightsRoute: typeof OOrgSlugTasksInsightsRoute
  OOrgSlugTasksNewRoute: typeof OOrgSlugTasksNewRoute
  OOrgSlugOrganizationIndexRoute: typeof OOrgSlugOrganizationIndexRoute
  OOrgSlugPeopleIndexRoute: typeof OOrgSlugPeopleIndexRoute
  OOrgSlugTasksIndexRoute: typeof OOrgSlugTasksIndexRoute
  OOrgSlugPeopleMembershipIdAccessRoute: typeof OOrgSlugPeopleMembershipIdAccessRoute
  OOrgSlugPeopleTeamsTeamIdRoute: typeof OOrgSlugPeopleTeamsTeamIdRoute
  OOrgSlugTasksTaskIdEditRoute: typeof OOrgSlugTasksTaskIdEditRoute
  OOrgSlugPeopleMembershipIdIndexRoute: typeof OOrgSlugPeopleMembershipIdIndexRoute
  OOrgSlugPeopleTeamsIndexRoute: typeof OOrgSlugPeopleTeamsIndexRoute
  OOrgSlugTasksTaskIdIndexRoute: typeof OOrgSlugTasksTaskIdIndexRoute
}

const OOrgSlugRouteRouteChildren: OOrgSlugRouteRouteChildren = {
  OOrgSlugIndexRoute: OOrgSlugIndexRoute,
  OOrgSlugOrganizationAuditRoute: OOrgSlugOrganizationAuditRoute,
  OOrgSlugOrganizationDangerRoute: OOrgSlugOrganizationDangerRoute,
  OOrgSlugOrganizationGeneralRoute: OOrgSlugOrganizationGeneralRoute,
  OOrgSlugOrganizationPlanRoute: OOrgSlugOrganizationPlanRoute,
  OOrgSlugOrganizationRolesRoute: OOrgSlugOrganizationRolesRoute,
  OOrgSlugPeopleInvitationsRoute: OOrgSlugPeopleInvitationsRoute,
  OOrgSlugPeopleInviteRoute: OOrgSlugPeopleInviteRoute,
  OOrgSlugTasksInsightsRoute: OOrgSlugTasksInsightsRoute,
  OOrgSlugTasksNewRoute: OOrgSlugTasksNewRoute,
  OOrgSlugOrganizationIndexRoute: OOrgSlugOrganizationIndexRoute,
  OOrgSlugPeopleIndexRoute: OOrgSlugPeopleIndexRoute,
  OOrgSlugTasksIndexRoute: OOrgSlugTasksIndexRoute,
  OOrgSlugPeopleMembershipIdAccessRoute: OOrgSlugPeopleMembershipIdAccessRoute,
  OOrgSlugPeopleTeamsTeamIdRoute: OOrgSlugPeopleTeamsTeamIdRoute,
  OOrgSlugTasksTaskIdEditRoute: OOrgSlugTasksTaskIdEditRoute,
  OOrgSlugPeopleMembershipIdIndexRoute: OOrgSlugPeopleMembershipIdIndexRoute,
  OOrgSlugPeopleTeamsIndexRoute: OOrgSlugPeopleTeamsIndexRoute,
  OOrgSlugTasksTaskIdIndexRoute: OOrgSlugTasksTaskIdIndexRoute,
}

const OOrgSlugRouteRouteWithChildren = OOrgSlugRouteRoute._addFileChildren(
  OOrgSlugRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AccountRouteRoute: AccountRouteRouteWithChildren,
  InboxRouteRoute: InboxRouteRouteWithChildren,
  MeRouteRoute: MeRouteRouteWithChildren,
  PlatformRouteRoute: PlatformRouteRouteWithChildren,
  DemoRoute: DemoRoute,
  DevRoute: DevRoute,
  ForgotRoute: ForgotRoute,
  MaintenanceRoute: MaintenanceRoute,
  ResetRoute: ResetRoute,
  SignInRoute: SignInRoute,
  SignUpRoute: SignUpRoute,
  VerifyRoute: VerifyRoute,
  OOrgSlugRouteRoute: OOrgSlugRouteRouteWithChildren,
  GalleryComponentIdRoute: GalleryComponentIdRoute,
  InviteCodeRoute: InviteCodeRoute,
  WelcomeProfileRoute: WelcomeProfileRoute,
  GalleryIndexRoute: GalleryIndexRoute,
  WelcomeIndexRoute: WelcomeIndexRoute,
  WelcomeInviteSlugRoute: WelcomeInviteSlugRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
